goog.provide('el8.appshared.mindreaderOpts');

goog.require('el8.appservice.notifier');
// This is still causing circular dependencies mindreaderOpts -> mindreaderOpts
// goog.require('el8.appshared.dialog.createPatient');
goog.require('el8.app.shared.dialog.enterpriseImportPatient');
goog.require('el8.data.cptCodes');
goog.require('el8.data.icd9Codes');
goog.require('el8.data.medications');
goog.require('el8.data.snomedCodes');
goog.require('el8.model.identify');
goog.require('el8.ptdata.ptProviders');
goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.shared.util.billing');
goog.require('el8.template.appshared.imo');
goog.require('el8.template.mindreader');
goog.require('el8.uiwidget.confirm');
goog.require('el8.util.base');
goog.require('el8.template.appchart.visitNote.GenericBillDialog');


el8.appshared.mindreaderOpts = {

    /**
     * Mindreader opts for specific data
     */
    allergies: function() {
        return {
            url: '/s/search/allergies/',
            limit: 75,
            sections: [
                {name: 'popular', title: 'Most Popular'},
                {name: 'matches', title: 'Best Matches'}
            ],
            formatResult: function(item) {
                return el8.template.mindreader.allergy({item: item});
            },
            formatSelected: function(item) { return item.name; }
        };
    },
    codedDocumentTags: function() {
        return {
            url: function() { return el8.service.urls.get('documentTags'); },
            formatResult: function(item) {
                return el8.template.mindreader.codedDocumentTag({item: item});
            },
            formatSelected: function(item) { return item.value; }
        };
    },
    maintItemRuleDocumentTags: function(docTagIds) {
        this.docTagIds = docTagIds;
        var _fn = function() {
            var dts = _.map(this.docTagIds, function (id) {
                return el8.data.docTags.getById(id);
            });
            return _.map(dts, function(item) { return item.asSoyMap(); });
        };

        return {
            data: _.bind(_fn, this),
            rowToStringFn: function(obj) { return obj['value'] + ' ' + obj['description'] + obj['code']; },
            formatResult: function(item) { return el8.template.mindreader.codedDocumentTag({item: item}); },
            formatSelected: function(item) { return item.value; }
        };
    },
    availablePtTags: function() {
        return {
            url: function() { return el8.service.urls.get('availablePtTags'); },
            formatResult: function(item) { return item.value; },
            formatSelected: function(item) { return item.value; }
        };
    },
    cptCodes: function() {
        return {
            url: function() { return el8.service.urls.get('cptCodes'); },
            limit: 25,
            newMindreader: true,
            formatResult: function(item) {
                return el8.template.mindreader.cptCode({item: item});
            },
            formatSelected: function(item) { return item.code; },
            containerWidth: 250,
            minQueryLength: 1,
            emptyQueryData: function() {
                return el8.data.cptCodes.sortedAsSoyMaps();
            },
            emptyQueryText: "Your practice's popular CPT codes:",
            actions: [{
                name: 'Manage CPT list...',
                actionFn: function() { window.open('/settings/billing/'); }
            }],
            customContainerFn: el8.template.appchart.visitNote.GenericBillDialog.mindreaderContainer
        };
    },
    icd9Codes: function() {
        return {
            url: function() { return el8.service.urls.get('searchIcd9'); },
            urlParams: {'billable': 1},
            limit: 50,
            containerWidth: 300,
            formatResult: function(item) {
                return el8.template.mindreader.icd9({item: item});
            },
            formatSelected: function(item) { return item.code; },
            newMindreader: true,
            selectFn: function(event, item) {
                return el8.data.icd9Codes.create(item);
            },
            minQueryLength: 1
        };
    },
    snomedCodes: function() {
        return {
            url: function() { return el8.service.urls.get('snomedCodes'); },
            limit: 50,
            containerWidth: 400,
            minQueryLength: 2,
            queryDelay: 0.33, // IMO recommends this delay amount
            formatResult: function(item) {
                if (item.imo_code) {
                    // This is an IMO code as JSON from IMO search OR from a current
                    // problem IMO object's autocompleteMap (e.g. when showing current problems
                    // in the assesment section as emptyQueryData)

                    // IMO are HTML escaped and may contain entities not in our simple
                    // whitelist, we have a non-whitelist-based function to unescape a
                    // broader set from IMO
                    item.title = item.title.el8_unescape_more();
                    return el8.template.mindreader.snomed({item: item});
                } else {
                    return el8.template.mindreader.legacySnomed({item: item});
                }
            },
            formatSelected: function(item) { return item.imo_code ? item.snomed : item.code; },
            newMindreader: true,
            selectFn: function(event, item) {
                if (item.imo_code) {
                    var imo = el8.data.imos.getByKey(item.imo_code);
                    item.title = imo.snomed_description;
                }
                return el8.data.snomedCodes.create(item);
            },
            customContainerFn: el8.template.appshared.imo.mindreaderContainer
        };
    },
    // You'll generally want to use imosWithActiveAndRecentProblems for IMO autocompletes.
    // It has emptyQueryData based on the active problem list + the most recent signed
    // note + any unsigned notes. `imos` is for places where you don't want any empty
    // query data (basically, the problem dialog). `imosWithActiveAndRecentSignedProblems`
    // is for places where you don't want any problems from unsigned notes
    // (basically, other unsigned notes).
    imos: function(fallbackMode) {
        return {
            newMindreader: true,
            url: function() { return el8.service.urls.get('searchImos'); },
            urlParams: { fallback_mode: fallbackMode },
            limit: 50,
            containerWidth: el8.data.practiceSettings.isHccScoringEnabled() ? 560 : 515, // wider MR container to fit HCCs
            containerHeight: 330,
            minQueryLength: 2,
            queryDelay: 0.33, // IMO recommends this delay amount
            formatResult: function(item) {
                if (item.imo_code) {
                    // This is an IMO code as JSON from IMO search OR from a current
                    // problem IMO object's autocompleteMap (e.g. when showing current problems
                    // in the assesment section as emptyQueryData)

                    // IMO are HTML escaped and may contain entities not in our simple
                    // whitelist, we have a non-whitelist-based function to unescape a
                    // broader set from IMO
                    item.title = item.title.el8_unescape_more();

                    if (item.hcc_community_factors) {
                        item.hcc_community_factors = el8.util.string.reducePrecision(item.hcc_community_factors);
                    }

                    // FUTURE: Identify ICD-10 codes as valid/invalid based on Date of Service
                    var timeNowMs = Date.now();

                    // Currently, only auto-populated IMO terms hydrate with effective dates
                    var isTermNonBillable = false;
                    if (item.icd10_effective_dates) {
                        isTermNonBillable = _.some(item.icd10_effective_dates, function (period) {
                            var startDate = period[0];
                            var endDate = period[1];
                            var isCodeInvalid = el8.shared.util.billing.isCodeNonBillable(startDate, endDate, timeNowMs);
                            return isCodeInvalid;
                        });
                    }
                
                    // Visually disables, but does not prevent selection in MR?
                    var isTermDisabled = el8Globals.FEATURES.BillDxAllowInvalid ? false : isTermNonBillable;

                    return el8.template.appshared.imo.term({
                        term: item,
                        mindreader: true,
                        hccScoringEnabled: el8.data.practiceSettings.isHccScoringEnabled(),
                        isTermNonBillable: isTermNonBillable,
                        isTermDisabled: isTermDisabled
                    });
                } else if (_.contains(['ICD10Code', 'ICD9Code'], item.model_class)) {
                    // This is an ICD10 or ICD9, for when IMO fails. We'll show n/a for the other code type
                    // {"score": 2.620683, "code": "V85", "mapped_snomed": null, "id": 25640370225, "description": "Body Mass Index [Bmi]"}
                    return el8.template.appshared.imo.legacyTerm({
                        term: item,
                        mindreader: true
                    });
                }
            },
            customContainerFn: el8.template.appshared.imo.mindreaderContainer
        };
    },
    imosWithActiveAndRecentProblems: function(fallbackMode) {
        var needsXwalkCount = el8.ptdata.ptProblems.getAllActive().filter(function(prob) {
            return prob.getNonImoIcd9Codes().length > 0;
        }).length;
        var emptyQueryText = (needsXwalkCount) ?
            "Displaying patient's recent and crosswalked, active problems. Note that some problems still need to be crosswalked." :
            "Displaying patient's recent and crosswalked, active problems:";

        return $.extend(this.imos(fallbackMode), {
            showOnFocus: true,
            emptyQueryData: function() { return el8.ptdata.ptProblems.getActiveImoAutocomplete(true); },
            emptyQueryText: emptyQueryText
        });
    },
    imosWithActiveAndRecentSignedProblems: function(fallbackMode, includeDeletedImos) {

        return $.extend(this.imosWithActiveAndRecentProblems(fallbackMode), {
            emptyQueryData: function() { return el8.ptdata.ptProblems.getActiveImoAutocomplete(false, includeDeletedImos); }
        });
    },
    checklistTemplates: function(type) {
        return {
            url: function() { return el8.service.urls.get('checklistTemplates'); },
            urlParams: { type: type },
            newMindreader: true,
            formatResult: function(item) { return item.name; },
            formatSelected: function(item) { return null; },
            containerHeight: 150,
            containerWidth: 350,
            emptyQueryData: function() {
                return el8.data.checklistTemplates.allType(type)
                    .filter(function(t) { return t.isPracticeOwned(); })
                    .map(el8.model.toSoyMapFn);
            },
            emptyQueryText: "Click to insert " + type.toUpperCase(),
            minQueryLength: 1,
            hideNoResults: true,
            noRepeatEmptyQuery: true
        };
    },
    medicalSpecialties: function() {
        return {
            url: function() { return el8.service.urls.get('searchMedicalSpecialties'); },
            limit: 10,
            entryHeight: 25,
            containerWidth: 325,
            formatResult: function(item) {
                return el8.template.mindreader.specialty({item: item});
            },
            formatSelected: function(item) {
                return item.name || '';
            }
        };
    },
    patient: function(spec) {
        spec = spec || {};
        return {
            url: function() {
                var suppressId = el8.ptdata.currPatient ? el8.ptdata.currPatient.getId() : null;
                return '/s/search/patient-name/' + (suppressId ? '?suppress_id='+suppressId : '');
            },
            limit: 50,
            containerWidth: 550,
            adviceText: 'Narrow search by adding patient date of birth "DOB:MM/DD/YYYY"',
            selectFn: spec.selectFn,
            formatResult: function(item) {
                // Take these from server-formatted datetimes to local dates
                if (item.last_seen) {
                    item.last_seen = el8.service.tz.toTzDateTime(item.last_seen).asString();
                }
                if (item.next_appt) {
                    item.next_appt = el8.service.tz.toTzDateTime(item.next_appt).asString();
                }
                return el8.template.mindreader.patient({item: item});
            },
            formatSelected: function(item) {
                return item.name || '';
            },
            transformResultsForRender: function (results) {
                return {
                  matches: results.local,
                  total_count: results.total_local_count,
                };
            }
        };
    },
    enterpriseAwarePatient: function(spec) {
        // if we turned off PLR, pretend there is no enterprise patient search
        var urlParams = el8Globals.FEATURES.PLR ? { 'ent': 1 } : {};

        spec = spec || {};

        var actions = [];
        // Exclude this button from the population AND settings page...
        // and maybe the reports page too
        // because creating patient doesn't work there either.
        var EXCLUDED_PATHS = ['settings', 'population'];
        var paths = window.location.pathname.split('/').filter(function (path) { return !!path; });
        if (!paths[0] || EXCLUDED_PATHS.indexOf(paths[0]) === -1) {
          actions.push({
              name: 'Create a new patient chart with this name...',
              actionFn: function(val) {
                  el8.appshared.dialog.createPatient.show({
                      name: val,
                      amplitudeSource: spec.location || null,
                      saveCallbackFn: spec.createNewCallbackFn || null
                  });
              }
          });
        }

        return $.extend(this.patient(spec), {
            urlParams: urlParams,
            selectFn: function(event, item, mindreader) {

                if (el8Globals.FEATURES.PLR && item.practice_id &&
                        item.practice_id !== el8Globals.PRACTICE_ID) {

                    el8.app.shared.dialog.enterpriseImportPatient.show({
                        patientId: item.id,
                        yesCallbackFn: function(newPatientId, importedLhs) {
                            var item = el8.ptdata.patients.getById(newPatientId);
                            var autocompleteMap = item.asAutocompleteMap();
                            // signal to chart that we've established a new enterprise chart
                            // and if we imported the LHS (which implies only 1 existing collaborator)
                            if (!importedLhs) {
                                autocompleteMap.url += '?lhs_imported=0';
                            } else {
                                autocompleteMap.url += '?lhs_imported=1';
                            }
                            mindreader.setSelectedItem(null, autocompleteMap);
                            if (spec.selectFn) { spec.selectFn({}, autocompleteMap, mindreader); }
                        },
                        noCallbackFn: function() {
                            mindreader.setInputVal('', true);
                        },
                        location: spec.location
                    });

                } else {
                    if (spec.selectFn) { spec.selectFn.apply(this, arguments); }
                }
            },
            sectionToTitleMap: {
                local: 'Results within your practice',
                enterprise: function() {
                    // needs to be a function because sometimes mindreaderOpts is invoked
                    // before el8.data.currPractice is set up
                    return 'Results from ' + el8.data.currPractice.getEnterpriseName();
                }
            },
            transformResultsForRender: function (results) {
              // Hide enterprise results if not showing all local results - this
              // logic previously existed on the backend but is now done on the
              // frontend to keep the API clean.
              var showingAllLocalResults = results.local.length === results.total_local_count;
              if (!el8Globals.FEATURES.PLR || !showingAllLocalResults) {
                return {
                  matches: results.local,
                  total_count: results.total_local_count,
                };
              }

              return {
                sections: ['local', 'enterprise'],
                local: results.local,
                enterprise: results.enterprise,
                total_local_count: results.total_local_count,
              };
            },
            modifyRenderCb: function(params) {
                if (!params.resultsMap.local || !params.resultsMap.enterprise) { return; }

                // This is a replacement for adviceText, which is broken by multi-section
                // results (let the user know there are more results not shown)
                var numLocalMatches = params.resultsMap.local.length;
                var localTotal = params.resultsMap.total_local_count;
                if (localTotal > numLocalMatches) {
                    params.infoDiv.text(
                        'Displaying ' + numLocalMatches + ' results of ' + localTotal +
                        ' for "' + params.searchString + '" in your practice.' +
                        ' Narrow search by adding patient date of birth "DOB:MM/DD/YYYY"'
                    );
                }

                // Specifically call out that we searched both the practice and enterprise
                // and found no results in either
                if (params.numMatches === 0) {
                    var inClause = 'in your practice.';
                    if (el8.data.currPractice.getEnterpriseName()) {
                        inClause = 'in your practice or ' + el8.data.currPractice.getEnterpriseName() + '.';
                    }
                    params.infoDiv.text(
                        'No results found for "' + params.searchString +'" ' + inClause
                    );
                }
            },
            showOnFocus: true,
            actions: actions
        });
    },
    physicians: function(spec) {
        spec = spec || {};
        var suggestMainProviders = (spec.autoSuggestOnFocus !== false); // default true
        var defaultFormatSelected = function(item) {
            return item.name || '';
        };
        var actions = [];
        if (el8Globals.FEATURES.ProvidersNetwork) {
            actions.push({
                name: 'Search in Elation Provider Network...',
                actionFn: function(val) {
                    el8.appchart.providers.main.show({searchString: val});
                }
            });
        }
        // test accounts get a limited provider search without Canonicals; PASSPORT_EMR gets the normal view
        var urlFn = function() {
            return el8.data.currUser.isPracticeAuthenticated() || el8Globals.PASSPORT_EMR ?
                el8.service.urls.get('searchConnections') : el8.service.urls.get('searchTestAcctConnections');
        };
        var opts = {
            url: urlFn,
            urlParams: spec.urlParams || {},
            formatResult: function(item) {
                if (!item) {return false;}

                if (item.model_class === 'CMSPhysician') {
                    return el8.template.mindreader.cmsPhysician({item: item});
                } else {
                    if (el8Globals.FEATURES.PLR4Everyone) {
                        el8.ptdata.careTeamProviders.applyPlrStatusToMindreaderItem(item);
                        // add in the PLR sharing info for this item
                    }
                    return el8.template.mindreader.physicianMedGroup({item: item});
                }
            },
            formatSelected: spec.formatSelectedFn || defaultFormatSelected,
            entryContainerClasses: [],
            actions: actions,
            newMindreader: true
        };

        if (el8Globals.FEATURES.ProvidersNetwork && suggestMainProviders) {
            // we could probably fetch this just once and cache it, but then we have to
            // deal with updating the data when the provider list updates
            opts['emptyQueryData'] = function() {
                return el8.ptdata.ptProviders.allMain().map(function(provider) {
                    var physician = provider.getPhysician();
                    if (!physician) { return null; }
                    var map = physician.asSolrMap();
                    map['provider_logo'] = provider.getProviderLogo();
                    map['public_access_user_id'] = provider.getPublicAccessUserId();
                    map['specialties'] = _.pluck(map['specialties'], 'name'); // Solr returns a flat list of names
                    return map;
                });
            };
            opts['modifyRenderCb'] = function(params) {
                if (!params.searchString && params.numMatches) {
                    // description for the emptyQueryData search
                    params.infoDiv.text(
                        "Displaying pt's provider list. Type to search for other providers."
                    );
                } else if (!params.numMatches && el8.appchart.letters.faxGuide.isInProgress()) {
                    $(document).trigger('letter-no-results'); // for letter FTUE
                }
            };
        } else {
            opts['modifyRenderCb'] = function(params) {
                if (!params.numMatches && el8.appchart.letters.faxGuide.isInProgress()) {
                    $(document).trigger('letter-no-results'); // for letter FTUE
                }
            };
        }

        var coerceContactType = function(item) {
            if (item && item.id && el8.model.idToModelClass(item.id) === 'CanonicalPhysician') {
                el8.appservice.notifier.notify('Creating new connection...');
                // we could maybe make this async if we moved it into clickItemOpts, but that would introduce
                // bugs if we use this mindreader without a clickItem, which we wouldn't want
                el8.data.physicians.physicianFromCanonical(item.id, {
                    async: false, // it would be better if this were async, but we need this to happen before the ClickItem's selectFn gets involved
                    successCb: function(physician) {
                        el8.appservice.notifier.notify('New connection created');
                        item.id = physician.getId(); // we want to use our practice-local ID, not a global one
                        item.model_class = el8.model.idToModelClass(item.id);
                    }
                });
            }
        };
        // A hack: we were using changeFn to listen for the need to validate our contact,
        // but it turns out the changeFn doesn't fire for listeditor-mindreaders.
        // selectFn should actually serve our needs here for ClickItems too, but we're
        // being conservative and just changing the broken context
        if (spec.listeditorFriendly) {
            opts['selectFn'] = function(e, item) {
                coerceContactType(item);
            };
        } else {
            opts['changeFn'] = function(e, mr) {
                var item = mr.getSelectedItem();
                coerceContactType(item);
            };
        }
        return opts;
    },
    referringProvider: function(spec) {
        var defaultFormatResult = function(item) {
            if (!item) {return false;}
            return el8.template.mindreader.referringProvider({item: item});
        };
        var defaultFormatSelected = function(item) {
            if (!item) {return false;}
            return item.name + ' (' + (item.phone ? item.phone : '') + ')';
        };

        var opts = {
            url: spec.url,
            minQueryLength: 3,
            formatSelected: spec.formatSelected || defaultFormatSelected,
            formatResult: spec.formatResult || defaultFormatResult,
            newMindreader: true,
            selectFn: spec.selectFn
        };

        return opts;
    },
    canonicalPhysician: function(spec) {
        var defaultFormatResult = function(item) {
            if (!item) {return false;}
            return el8.template.mindreader.referringProvider({item: item});
        };
        var defaultFormatSelected = function(item) {
            if (!item) {return false;}
            return item.name + ' (' + (item.specialty_category ? item.specialty_category : '') + ')';
        };

        var opts = {
            url: spec.url,
            minQueryLength: 3,
            formatSelected: spec.formatSelected || defaultFormatSelected,
            formatResult: spec.formatResult || defaultFormatResult,
            newMindreader: true,
            selectFn: spec.selectFn
        };

        return opts;
    },
    labOrderTestsSets: function(compendiumId) {
        return {
            newMindreader: true,
            url: function() {
                return el8.service.urls.get('searchLabOrderTestsSets', [compendiumId]);
            },
            formatResult: function(item) {
                if (el8.model.idToModelClass(item.id) === 'LabOrderTest') {
                    return el8.template.mindreader.labOrderTest({item: item});
                } else if (el8.model.idToModelClass(item.id) === 'LabOrderSet') {
                    return el8.template.mindreader.labOrderSet({item: item});
                }
            }
        };
    },
    labOrderTests: function(compendiumId) {
        return $.extend(this.labOrderTestsSets(), {
            url: function() {
                return el8.service.urls.get('searchLabOrderTests', [compendiumId]);
            }
        });
    },
    practiceUsers: function() {
        return {
            data: function() { return el8.data.practiceUsers.all(); },
            formatResult: function(item) { return item.getFullName(); },
            rowToStringFn: function(item) { return item.getFullName(); },
            newMindreader: true,
            minQueryLength: 1
        };
    },
    practiceUsersAndStaffGroups: function() {
        var itemToStringFn = function(item) {
            if (item.getModelClass() === 'User') { // User is not an el8Id
                return item.getFullName();
            } else if (el8.model.idToModelClass(item.getId()) === 'StaffGroup') {
                return item.getName() + ' (Group)';
            }
        };
        return {
            data: function() {
                var users = el8.data.practiceUsers.all();
                var groups = el8.data.staffGroups.all();
                return users.concat(groups);
            },
            formatResult: itemToStringFn,
            rowToStringFn: itemToStringFn,
            newMindreader: true,
            minQueryLength: 1
        };
    },
    insuranceCompanies: function() {
        return {
            url: function() { return el8.service.urls.get('insuranceCompanies'); },
            limit: 50,
            containerWidth: 400,
            formatSelected: function(item) { return item.carrier; },
            formatResult: function(item) {
                return el8.template.mindreader.insuranceCompany({item: item});
            }
        };
    },
    insurancePlansWithCompanies: function() {
        return {
            url: function() { return el8.service.urls.get('insurancePlansWithCompanies'); },
            limit: 50,
            containerWidth: 400,
            formatSelected: function(item) { return item.name; },
            formatResult: function(item) {
                return el8.template.mindreader.insurancePlanWithCompany({item: item});
            }
        };
    },
    medications: function(opts) {
        var mrOpts = {
            url: '/s/search/medications/',
            limit: 75,
            formatResult: function(item) {
                // need to map the search response to a frontend object so we can execute
                // logic to evaluate state drug schedule, and also be more consistent
                // in how we handle the field names in templates that deal w/ mindreader data
                var med = el8.data.medications.create(item);
                return el8.template.mindreader.medication({item: med.asSoyMap()});
            },
            formatSelected: function(item) {
                return item.clean_name;
            }
        };
        _.extend(mrOpts, opts);
        return mrOpts;
    },
    qtyUnits: function() {
        return {
            data: el8.util.consts.MED_ORDER_QUANTITY_DISPLAY_UNITS,
            minQueryLength: 1
        };
    }
};
